export default "__VITE_ASSET__Dmm4KBtK__"